export default "__VITE_ASSET__YU7FSkPN__"